import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router";

import SpaceliftLoader from "components/loading/SpaceliftLoader";

type RedirectToLoginProps = {
  setItem: (key: string, pathname: string) => unknown;
};

const RedirectToLogin = (props: RedirectToLoginProps) => {
  const { setItem } = props;
  const { pathname, search } = useLocation();
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    setItem("redirectTo", `${pathname}${search}`);
    setRedirect(true);
  }, [setItem, pathname, search]);

  if (redirect) {
    return <Navigate to="/login" replace />;
  }

  return <SpaceliftLoader />;
};

export default RedirectToLogin;
